import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  className?: string;
}

const TabPanel = ({ children, index, value, className }: TabPanelProps) => {
  return (
    <div
      hidden={value !== index}
      className={className}
    >
      {value === index && <>{children}</>}
    </div>
  );
};

export default TabPanel;
